import React from "react";
import { IoCaretForwardOutline } from "react-icons/io5";

function PagesHero({ page }) {
  // const bg =
  //   (pageBackground && (pageBackground.default || pageBackground)) || "/c.jpg";
  // console.log(page);
  
  const bg = `/images/${page}_hero.jpg`;
    
  return (
    <div className="pages_hero" style={{
      background: `linear-gradient(rgba(10,10,10,0.45), rgba(0,0,0,0.8)), url("${bg}") center / cover no-repeat`
    }}>
      <div className="page_hero_container">
        <h2>{page}</h2>
        <div>
          <h4 style={{color: "white"}}>Home</h4>
          <span>
            <IoCaretForwardOutline />
          </span>
          <p>{page}</p>
        </div>
      </div>
    </div>
  );
}

export default PagesHero;
